import type { QueryClient } from "@tanstack/react-query";
import { openBalanceQueryKey } from "@/features/balance/utils/open-balance";
import { createAuthenticatedApi } from "@/lib/utils";
import { studioTodayYmd } from "@/lib/utils/date/studio-clock";
import { PaymentApi } from "@/openapi/generated";
import { ResponseError } from "@/openapi/generated/runtime";

export async function prefetchOpenBalanceGet(
  userId: number,
  queryClient: QueryClient,
  accessToken: string,
  tenantId: number,
  timeZone?: string | null,
) {
  const billingDateYmd = studioTodayYmd(new Date(), timeZone);
  const service = createAuthenticatedApi(PaymentApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: openBalanceQueryKey(userId, billingDateYmd),
    queryFn: async () => {
      try {
        const rows = await service.apiPaymentsOpenBalanceGet({
          userId,
          billingDate: billingDateYmd,
          xTenantID: tenantId,
        });
        return rows ?? [];
      } catch (error) {
        if (
          error instanceof ResponseError &&
          (error.response.status === 404 || error.response.status === 403)
        ) {
          return [];
        }
        console.error("[BalancePage SSR] open balance failed", {
          userId,
          error,
        });
        return [];
      }
    },
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
